import Svg, { Path, type PathProps, type SvgProps } from 'react-native-svg'
import { mesaColorNames } from '@/src/common/theme'

export function HomeOutlined({
  svgProps,
  pathProps,
  outlineColor,
  width = 24,
  height = 24,
}: {
  svgProps?: SvgProps
  pathProps?: PathProps
  outlineColor?: string
  width?: number
  height?: number
}) {
  return (
    <Svg width={width} height={height} viewBox="0 0 24 24" fill="none" {...svgProps}>
      <Path
        d="M4.00001 11C4.00001 10.3705 4.2964 9.77771 4.80001 9.4L10.8 4.9C11.5111 4.36667 12.4889 4.36667 13.2 4.9L19.2 9.4C19.7036 9.77771 20 10.3705 20 11V17C20 18.6569 18.6569 20 17 20H7C5.34314 20 4 18.6569 4 17L4.00001 11Z"
        stroke={outlineColor ?? mesaColorNames['Greyscale/400 #A4AAAC']}
        strokeWidth={1.5}
        {...pathProps}
      />
    </Svg>
  )
}
